import Operation from './Operation';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import Slider from '@mui/material/Slider';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ControlledWhenBlurredTextfield from '../../ControlledWhenBlurredTextfield';
import produce from 'immer';
import { useProbeFeatureTCPCHandles } from '../../viewer3d/probing/operations/ProbeFeatureTCPC';

import { useSelector } from 'react-redux';
import { selectToolLengthOffset, selectJoints } from '../../../selectors/machine-state';

export default function ProbeFeatureTCPC(props) {
  const {
    machine,
    onSave
  } = props;

  const {
    tempArgs,
    setTempArgs
  } = useProbeFeatureTCPCHandles();

  const {
    cmds
  } = tempArgs;

  const joints = useSelector(selectJoints);
  const toolLengthOffset = useSelector(selectToolLengthOffset);
  const handleSave = () => {
    onSave(tempArgs);
  };

  return (<Operation {...props}>
    { cmds.map((cmd, i) => {
      const {
        cmd: tcpcCmd,
        args
      } = cmd;

      const {
        point
      } = args;

      const globalPoint = machine.inverseFiveAxis({ X: point.x, Y: point.y, Z: point.z, B: joints[3], C: joints[4] }, toolLengthOffset);
      globalPoint[2] -= toolLengthOffset;

      const handleSliderChangeX = ((i) => (e,v) => {
        const newPoint = machine.forwardFiveAxis([ v, globalPoint[1], globalPoint[2], globalPoint[3], globalPoint[4] ], 0);
        const newTcpcCmdArgs = produce(tempArgs, (args) => {
          args.cmds[i].args.point.x = newPoint.X;
          args.cmds[i].args.point.y = newPoint.Y;
          args.cmds[i].args.point.z = newPoint.Z;
        });
        setTempArgs(newTcpcCmdArgs);
      })(i);
      const handleSliderChangeY = ((i) => (e,v) => {
        const newPoint = machine.forwardFiveAxis([ globalPoint[0], v, globalPoint[2], globalPoint[3], globalPoint[4] ], 0);
        const newTcpcCmdArgs = produce(tempArgs, (args) => {
          args.cmds[i].args.point.x = newPoint.X;
          args.cmds[i].args.point.y = newPoint.Y;
          args.cmds[i].args.point.z = newPoint.Z;
        });
        setTempArgs(newTcpcCmdArgs);
      })(i);
      const handleSliderChangeZ = ((i) => (e,v) => {
        const newPoint = machine.forwardFiveAxis([ globalPoint[0], globalPoint[1], v, globalPoint[3], globalPoint[4] ], 0);
        const newTcpcCmdArgs = produce(tempArgs, (args) => {
          args.cmds[i].args.point.x = newPoint.X;
          args.cmds[i].args.point.y = newPoint.Y;
          args.cmds[i].args.point.z = newPoint.Z;
        });
        setTempArgs(newTcpcCmdArgs);
      })(i);

      return <Paper key={tcpcCmd + i} variant="outlined" sx={{ margin: 1, padding: 1 }}>
        <Select value={tcpcCmd} size="small">
          <MenuItem value={"move"}>Move</MenuItem>
          <MenuItem value={"probe"}>Probe</MenuItem>
        </Select>
        
       <Stack direction="row" spacing={2} alignItems="center"><Box>X</Box><Slider step={.0001} min={machine.limits.extents.min[0]} max={machine.limits.extents.max[0]} value={globalPoint[0]} onChange={handleSliderChangeX} onChangeCommitted={handleSave}/><ControlledWhenBlurredTextfield value={globalPoint[0].toFixed(4)} inputProps={{ inputMode: 'numeric', pattern: '[0-9-.]*', style: { padding: 4, margin: 0 }}}/></Stack>
       <Stack direction="row" spacing={2} alignItems="center"><Box>Y</Box><Slider step={.0001} min={machine.limits.extents.min[1]} max={machine.limits.extents.max[1]} value={globalPoint[1]} onChange={handleSliderChangeY} onChangeCommitted={handleSave}/><ControlledWhenBlurredTextfield value={globalPoint[1].toFixed(4)} inputProps={{ inputMode: 'numeric', pattern: '[0-9-.]*', style: { padding: 4, margin: 0 }}}/></Stack>
       <Stack direction="row" spacing={2} alignItems="center"><Box>Z</Box><Slider step={.0001} min={machine.limits.extents.min[2]-toolLengthOffset} max={machine.limits.extents.max[2]-toolLengthOffset} value={globalPoint[2]} onChange={handleSliderChangeZ} onChangeCommitted={handleSave}/><ControlledWhenBlurredTextfield value={globalPoint[2].toFixed(4)} inputProps={{ inputMode: 'numeric', pattern: '[0-9-.]*', style: { padding: 4, margin: 0 }}}/></Stack>
      </Paper>
    }) }
  </Operation>);
};
